export class Unspecified{
    flatRate?:number;
    percentBilled?:number;
    maxRate?:number; 
}